export const hasBusinessCategories = (value) => {
    if (Array.isArray(value)) return value.length > 0;
    if (value === null || value === undefined) return false;

    const text = String(value).trim();
    if (!text || text === '[]' || text.toLowerCase() === 'null') return false;

    try {
        const parsed = JSON.parse(text);
        return Array.isArray(parsed) ? parsed.length > 0 : Boolean(parsed);
    } catch {
        return true;
    }
};

export const hasAadhaarKyc = (history = []) => history.some((row) => {
    const type = String(row?.kyc_type || '').toLowerCase();
    const isAadhaarType = type.includes('aadhaar') || type.includes('adhaar');
    const hasPersonalAadhaar = row?.has_personal_aadhaar === true
        || (row?.personal_aadhaar !== null && row?.personal_aadhaar !== undefined);

    return isAadhaarType && hasPersonalAadhaar;
});

export const getVendorVerification = (vendor = {}, history = []) => {
    const gst = String(vendor.gst_number || '').trim();
    const gstState = !gst ? 'pending' : gst.toUpperCase() === 'N/A' ? 'skipped' : 'verified';

    const checks = [
        { key: 'gst', label: 'GST', state: gstState, detail: gstState === 'verified' ? gst : undefined },
        { key: 'kyc', label: 'Aadhaar KYC', state: hasAadhaarKyc(history) ? 'verified' : 'pending' },
        { key: 'logo', label: 'Company logo', state: vendor.company_logo_path ? 'verified' : 'pending' },
        { key: 'banner', label: 'Company banner', state: vendor.company_banner_path ? 'verified' : 'pending' },
        { key: 'categories', label: 'Category selection', state: hasBusinessCategories(vendor.business_categories) ? 'verified' : 'pending' }
    ];

    const completedCount = checks.filter((item) => item.state !== 'pending').length;

    return {
        checks,
        fullyVerified: Number(vendor.last_registration_step) === 12 && completedCount === checks.length,
        completedCount
    };
};
